import {FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {Component, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
    selector: 'common-ui-wirtschafts-id',
    templateUrl: './wirtschafts-id.component.html'
})
export class WirtschaftsIdComponent extends FormBaseComponent<Record<string, unknown>> {

    @Input()
    public label = 'COMMON_UI.STEUERIDENTIFIKATION.WIRTSCHAFTS_ID_NUMMER';

    @Input()
    public fieldName = 'wirtschaftsIdNummer';

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            [this.fieldName]: [this.data[this.fieldName], [
                this.validatorService.pattern(ValidationPattern.WIRTSCHAFTS_ID,
                    this.translateService.instant('COMMON_UI.VALIDATION.WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN'))
            ]]
        });
    }
}




